<main
  class="not-found"
  aria-labelledby="not-found-title"
  lang="es"
>
  <div class="not-found__content">
    <img
      class="not-found__brand"
      src="/assets/images/logo-argentus.png"
      alt="Argentus Mundo 3D"
      width="171"
      height="46"
    >

    <h1 id="not-found-title" class="not-found__title">
      No encontramos lo que buscas
    </h1>

    <p class="not-found__description">
      El producto o la página que buscas no está disponible.
      Puedes volver a la tienda y ver otros productos.
    </p>

    <nav
      class="not-found__actions"
      aria-label="Opciones para continuar navegando"
    >
      <a
        class="not-found__link not-found__link--primary"
        [routerLink]="catalogRoute"
      >
        <span aria-hidden="true">←</span>
        Volver a la tienda
      </a>
    </nav>
  </div>
</main>
